import {Action} from '@ngrx/store';
import {PagingModel} from '../models/paging-model';
import {Contact} from '../models/contact';
import {AdminContactResponse} from '../models/admin-contact-response';
import { ErrorModel } from '../models/error-model';

export const LOAD_CONTACT_LIST = '[Contact] LoadList';
export const LOAD_CONTACT_LIST_COMPLETE = '[Contact] LoadListComplete';
export const SAVE_CONTACT = '[Contact] Save';
export const SAVE_CONTACT_COMPLETE = '[Contact] SaveComplete';
export const GET_CONTACT_DETAILS = '[Contact] GetById';
export const GET_CONTACT_DETAILS_COMPLETE = '[Contact] GetByIdComplete';
export const GET_USER_PROFILE = '[Contact] GetProfile';
export const GET_USER_PROFILE_COMPLETE = '[Contact] GetProfileComplete';
export const SAVE_USER_PROFILE = '[Contact] SaveProfile';
export const SAVE_USER_PROFILE_COMPLETE = '[Contact] SaveProfileComplete';

export class LoadContactListAction implements Action {
  readonly type = LOAD_CONTACT_LIST;

  constructor(public payload: PagingModel) {}
}

export class LoadContactListCompleteAction implements Action {
  readonly type = LOAD_CONTACT_LIST_COMPLETE;

  constructor(public payload: AdminContactResponse) {}
}

export class SaveContactAction implements Action {
  readonly type = SAVE_CONTACT;

  constructor(public payload: Contact) {}
}

export class SaveContactCompleteAction implements Action {
  readonly type = SAVE_CONTACT_COMPLETE;

  constructor(public payload: Contact) {}
}

export class GetContactDetailsAction implements Action {
  readonly type = GET_CONTACT_DETAILS;

  constructor(public payload: number) {}
}

export class GetContactDetailsCompleteAction {
  readonly type = GET_CONTACT_DETAILS_COMPLETE;

  constructor(public payload: Contact) {}
}

export class GetUserProfileAction implements Action {
  readonly type = GET_USER_PROFILE;

  constructor(public payload: string) {}
}

export class GetUserProfileCompleteAction {
  readonly type = GET_USER_PROFILE_COMPLETE;

  constructor(public payload: Contact) {}
}

export class SaveUserProfileAction implements Action {
  readonly type = SAVE_USER_PROFILE;

  constructor(public payload: Contact) {}
}

export class SaveUserProfileCompleteAction {
  readonly type = SAVE_USER_PROFILE_COMPLETE;

  constructor(public payload: Contact) {}
}


export type Actions = LoadContactListAction |
  LoadContactListCompleteAction |
  SaveContactAction |
  SaveContactCompleteAction |
  GetContactDetailsAction |
  GetContactDetailsCompleteAction |
  GetUserProfileAction |
  GetUserProfileCompleteAction |
  SaveUserProfileAction |
  SaveUserProfileCompleteAction;



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/actions/contact.ts